import { useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function Profile() {
  const { user, login } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [avatar, setAvatar] = useState(user?.avatar || "");
  const [loading, setLoading] = useState(false);

  // ================= UPDATE NAME =================
  const saveProfile = async () => {
    try {
      setLoading(true);
      const res = await fetch("http://localhost:5000/api/profile", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({ name }),
      });

      const data = await res.json();
      login({ ...user, name: data.name });
      alert("Profile updated successfully");
    } finally {
      setLoading(false);
    }
  };

  // ================= UPLOAD AVATAR =================
  const uploadAvatar = async (file) => {
    if (!file) return;

    const form = new FormData();
    form.append("avatar", file);

    const res = await fetch(
      "http://localhost:5000/api/profile/avatar",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        body: form,
      }
    );

    const data = await res.json();
    setAvatar(data.avatar);
    login({ ...user, avatar: data.avatar });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-gray-900 to-black text-white flex justify-center py-14 px-4">
      <div className="w-full max-w-2xl">
        {/* ================= HEADER ================= */}
        <h1 className="text-3xl font-bold mb-8">
          My Profile
        </h1>

        {/* ================= CARD ================= */}
        <div className="bg-gray-900/70 backdrop-blur border border-gray-800 rounded-2xl shadow-2xl p-8">
          {/* AVATAR */}
          <div className="flex flex-col items-center">
            <div className="relative">
              <img
                src={avatar || "/default-avatar.png"}
                alt="avatar"
                className="w-32 h-32 rounded-full border-4 border-gray-700 object-cover"
              />

              {/* UPLOAD OVERLAY */}
              <label className="absolute bottom-2 right-2 bg-indigo-600 hover:bg-indigo-700 transition p-2 rounded-full cursor-pointer shadow-lg">
                ✏️
                <input
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={(e) =>
                    uploadAvatar(e.target.files[0])
                  }
                />
              </label>
            </div>

            <p className="mt-4 text-xl font-semibold">
              {user.name}
            </p>
            <p className="text-sm text-gray-400">
              {user.email}
            </p>
          </div>

          {/* ================= FORM ================= */}
          <div className="mt-10 space-y-6">
            <div>
              <label className="block text-sm text-gray-400 mb-1">
                Full Name
              </label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full bg-gray-800 border border-gray-700
                rounded-xl px-4 py-3 outline-none
                focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            {/* ACTIONS */}
            <div className="flex justify-end">
              <button
                disabled={loading}
                onClick={saveProfile}
                className={`px-6 py-3 rounded-xl font-semibold transition
                ${
                  loading
                    ? "bg-gray-600 cursor-not-allowed"
                    : "bg-indigo-600 hover:bg-indigo-700"
                }`}
              >
                {loading ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>

        {/* ================= FOOT NOTE ================= */}
        <p className="text-center text-xs text-gray-500 mt-6">
          Your profile information is securely stored and visible only to you.
        </p>
      </div>
    </div>
  );
}
